module.exports = __webpack_public_path__ + "static/about-us-03-36428bd85313becfd3bdfa2b0753fc3e.jpg";